import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Badge } from "../../components/ui/badge";
import { ChevronDown, ChevronUp } from "lucide-react";

/**
 * Blocco configurazione AI: chiuso di default, con titolo e pulsante Apri/Chiudi.
 */
export default function AiConfigCollapsibleCard({
  title,
  icon,
  description,
  statusLabel,
  statusActive = false,
  defaultOpen = false,
  className = "",
  contentClassName = "",
  children,
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Card className={className}>
      <CardHeader className="py-3">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0 flex-1">
            <CardTitle className="flex flex-wrap items-center gap-2 text-base">
              {icon}
              <span>{title}</span>
              {statusLabel != null && statusLabel !== "" && (
                <Badge
                  variant="outline"
                  className={
                    statusActive
                      ? "bg-emerald-50 text-emerald-700 border-emerald-200 text-[10px]"
                      : "bg-slate-50 text-slate-500 border-slate-200 text-[10px]"
                  }
                >
                  {statusLabel}
                </Badge>
              )}
            </CardTitle>
            {description && (
              <p className={`text-sm text-slate-500 mt-1 ${open ? "" : "line-clamp-2"}`}>
                {description}
              </p>
            )}
          </div>
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="shrink-0"
            onClick={() => setOpen((o) => !o)}
            aria-expanded={open}
          >
            {open ? <ChevronUp className="w-4 h-4 mr-1" /> : <ChevronDown className="w-4 h-4 mr-1" />}
            {open ? "Chiudi" : "Apri"}
          </Button>
        </div>
      </CardHeader>
      {open && (
        <CardContent className={contentClassName || undefined}>
          {children}
        </CardContent>
      )}
    </Card>
  );
}
